<li
  class="profile-nav profile-nav-tour onhover-dropdown"
  [class.clicked]="show"
  (click)="open()"
>
  <div class="media profile-media justify-content-center align-items-center">

    <!-- ✅ MOBILE: Profile Icon -->
    <div class="profile-icon">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;height:32px !important;width:32px !important" xml:space="preserve" class=""><g><path fill="#ffaa20" d="M512 256c0 74.922-32.191 142.328-83.488 189.148C383 486.672 322.46 512 256 512s-127-25.328-172.512-66.852C32.191 398.328 0 330.922 0 256 0 114.621 114.621 0 256 0s256 114.621 256 256zm0 0" opacity="1" data-original="#ffaa20" class=""></path><path fill="#ff8900" d="M512 256c0 74.922-32.191 142.328-83.488 189.148C383 486.672 322.46 512 256 512V0c141.379 0 256 114.621 256 256zm0 0" opacity="1" data-original="#ff8900"></path><path fill="#7985eb" d="M428.512 444.129v1.02C383 486.671 322.46 512 256 512s-127-25.328-172.512-66.852v-1.02c0-74.16 47.043-137.55 112.864-161.866 18.59-6.883 38.687-10.64 59.648-10.64s41.059 3.757 59.66 10.64c65.82 24.328 112.852 87.707 112.852 161.867zm0 0" opacity="1" data-original="#7985eb"></path><path fill="#4b5be6" d="M428.512 444.129v1.02C383 486.671 322.46 512 256 512V271.621c20.96 0 41.059 3.758 59.66 10.64 65.82 24.329 112.852 87.708 112.852 161.868zm0 0" opacity="1" data-original="#4b5be6" class=""></path><path fill="#ffdba9" d="M361.809 194.922c0 58.34-47.457 105.812-105.809 105.812-58.34 0-105.809-47.472-105.809-105.812S197.661 89.113 256 89.113c58.352 0 105.809 47.469 105.809 105.809zm0 0" opacity="1" data-original="#ffdba9" class=""></path><path fill="#ffc473" d="M361.809 194.922c0 58.34-47.457 105.812-105.809 105.812V89.114c58.352 0 105.809 47.468 105.809 105.808zm0 0" opacity="1" data-original="#ffc473" class=""></path></g></svg>
    </div>

    <!-- ✅ DESKTOP: Name + Role -->
    <div class="profile-text">
      <span class="profile-name">
        {{ profileName }}
      </span>

      <span class="login-type">
        {{ loginType }}
      </span>
    </div>

    <!-- Arrow -->
    <img
      src="assets/images/Icons/DownArrow.png"
      alt="DownArrow"
      [ngClass]="{ 'rotate-up': show, 'rotate-down': !show }"
      class="arrow"
    />
  </div>

  <!-- ✅ Dropdown -->
  <ul
    *ngIf="show"
    class="profile-dropdown"
    [ngClass]="{ 'active onhover-show-div': show }"
  >
    <!-- 👇 Add profile info here -->
    <li class="profile-info">
      <div class="name">{{ profileName }}</div>
      <div class="role">{{ loginType }}</div>
    </li>

    <li class="d-flex justify-content-center p-0 align-items-center gap-2" style="padding: 8px 0 !important;">
      <app-feathericon icon="lock" class="d-flex align-items-center"></app-feathericon>
      <a class="changepassword" data-bs-toggle="modal" data-bs-target="#ChangePassword">
        Change Password
      </a>
    </li>

    <li class="d-flex justify-content-center p-0">
      <a class="btn btn-pill btn-outline-primary btn-sm" (click)="logOut()">Log Out</a>
    </li>
  </ul>
</li>